import { createSlice } from '@reduxjs/toolkit';
const name = 'config';

const initialState = {
  codes: [],
  scAddress: undefined,
  tcAddress: undefined,
  startAt: undefined,
  rounds: [],
  refreshDelay: 30000,
  displayNum: 3,
  dontDisplayDiscount: undefined,
};

export const configSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.codes = action.payload?.codes ?? [];
      state.scAddress = action.payload?.saleContractAddress;
      state.tcAddress = action.payload?.tokenContractAddress;
      state.startAt = action.payload?.startAt;
      state.rounds = action.payload?.rounds ?? [];
      state.refreshDelay = Math.max(10000, action.payload?.refreshDelay ?? 0);
      state.displayNum = action.payload?.displayNum ?? 3;
      state.dontDisplayDiscount = action.payload?.dontDisplayDiscount;
    },
  },
});

export const { setConfig } = configSlice.actions;

export default configSlice.reducer;
